

import { useQuery } from "react-query";
import { setHeaders } from "../../../utils/basic";
import * as config from "../../../app.config";
import axios from "axios";

const getVersionData = async () => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/display/documentation/version`,
        {
            headers: headerConfig
        }
    );
    return data;
}

export const useFetchSoftwareVersion = (doc) => {
    return useQuery(["fetchSWVersion", doc], () => getVersionData(), {
        onSuccess: (data) => {
            //console.log({ data });
        },
        onError: (error) => {
            console.log({ error });
        }
    });
}